import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import {
  normalizeOrderReportSeriesPayload,
  normalizeOrderReportSummaryPayload,
  normalizeOrderReportTablePayload,
} from '../../../helpers/normalizeOrderReportResponse';

const initialState = {
  loading: false,
  summary: {},
  series: [],
  table: { data: [], total: 0, per_page: 10, current_page: 1 },
  error: '',
};

export const fetchOrdersSummary = createAsyncThunk(
  'orderReport/fetchOrdersSummary',
  (params = {}) => {
    return ReportService.getOrdersReport(
      normalizeReportParams({ ...params, view: 'summary', format: 'json' })
    ).then((res) => res);
  }
);

export const fetchOrdersSeries = createAsyncThunk(
  'orderReport/fetchOrdersSeries',
  (params = {}) => {
    return ReportService.getOrdersReport(
      normalizeReportParams({ ...params, view: 'series', format: 'json' })
    ).then((res) => res);
  }
);

export const fetchOrdersTable = createAsyncThunk(
  'orderReport/fetchOrdersTable',
  (params = {}) => {
    return ReportService.getOrdersReport(
      normalizeReportParams({ ...params, view: 'table', format: 'json' })
    ).then((res) => res);
  }
);

const orderCountSlice = createSlice({
  name: 'orderReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchOrdersSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrdersSummary.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.summary = normalizeOrderReportSummaryPayload(payload);
      state.series = normalizeOrderReportSeriesPayload(payload);
      state.error = '';
    });
    builder.addCase(fetchOrdersSummary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchOrdersSeries.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrdersSeries.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.series = normalizeOrderReportSeriesPayload(payload);
      state.error = '';
    });
    builder.addCase(fetchOrdersSeries.rejected, (state, action) => {
      state.loading = false;
      state.series = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchOrdersTable.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrdersTable.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.table = normalizeOrderReportTablePayload(payload);
      state.error = '';
    });
    builder.addCase(fetchOrdersTable.rejected, (state, action) => {
      state.loading = false;
      state.table = initialState.table;
      state.error = action.error.message;
    });
  },

  reducers: {
    filterOrderProduct(state, action) {
      // payload reserved for future filter logic
    },
  },
});
export const { filterOrderProduct } = orderCountSlice.actions;
export default orderCountSlice.reducer;
